export const READ_MESSAGE_STATUS = "read"
export const UNREAD_MESSAGE_STATUS = "unread"
